// EmployeeESIStatement

import { useState } from "react";
import { Reactable } from "../../components/ui/reactable";
import { EMPLOYEE_ESI_REPORTS } from "../../constants/api";
import { EmployeeDetails } from "../../components/ui/cards";
import { useNavigate } from "react-router-dom";
import { ChevronLeftIcon } from "lucide-react";

const EmployeeESIStatement = () => {

    const [employeeESIStatementData, setEmployeeESIStatementData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    let navigate = useNavigate()
    const EmployeeESIStatementColumns = [
        {
            accessor: "employee_name",
            Header: "Employee",
            sortable: true,
            fixed: true,
            filterable: true,
            maxWidth: "300px",
            Cell: ({ value, row }) => {
                const record = row;

                let empDetails = {
                    ...record?.employee,
                    designation_id: record?.employee?.designation
                        ? {
                            id: record?.employee.designation.id,
                            designation_name: record?.employee.designation.name,
                        }
                        : { id: 0, designation_name: "" },
                    first_name: record?.employee?.employee_name || "-",
                    id: record?.employee?.employee_id || "-",
                };

                return <EmployeeDetails details={empDetails} size="xs" />;
            },
        },
        {
            accessor: "ESI_no",
            Header: "ESI No",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "salary_days",
            Header: "Salary Days",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "ESI_Wages",
            Header: "ESI Wages",
            filterable: true,
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "ESI_Contirbutions",
            Header: "ESI Contributions",
            Cell: ({ value }) => value ?? "-",
        }
    ];

    return (
        <div className="p-4 dark:bg-gray-900 rounded-lg dark:shadow-md font-sans">
            <div className="flex justify-between items-center mb-4">
                <span className=" flex gap-2 items-center">
                    <ChevronLeftIcon onClick={() => { navigate('/reports') }} className=" cursor-pointer" />
                    <h1 className="text-2xl font-semibold text-gray-900 dark:text-gray-100">
                        Employee ESI Statements Report ({totalRecords})
                    </h1>
                </span>
            </div>

            <Reactable
                columns={EmployeeESIStatementColumns}
                data={employeeESIStatementData}
                setData={setEmployeeESIStatementData}
                setTotalCount={setTotalRecords}
                url={EMPLOYEE_ESI_REPORTS}
                serverSide={true}
                tableHeight="calc(100vh - 310px)"
                rowSize="sm"
                isCSVRequired={true}
                isPDFRequired={true}
                isMonthYearRequired={true}
            />
        </div >
    );
}

export default EmployeeESIStatement;